const statusLists = [
    { id:"1",name:"一线处理"},
    { id:"2",name:"二线处理"},
];
const companyList = [
    { id:"1",name:"公司1"},
    { id:"2",name:"公司2"},
];
// 变更类型
const categoryList = [
    { id:"1",name:"重大变更"},
    { id:"2",name:"较大表更"},
    { id:"3",name:"一般变更"},
    { id:"4",name:"日常变更"},
    { id:"5",name:"紧急变更"},
];
// 变更分类
const categoryList2 = [
    { id:"1",name:"设备变更"},
    { id:"2",name:"供应商变更"},

];

// 变更来源
const originList = [
    { id:"1",name:"请求"},
    { id:"2",name:"问题"},
    { id:"3",name:"其他"},

];
// 紧急程度
const emergencyList = [
    { id:"1",name:"紧急"},
    { id:"2",name:"高"},
    { id:"3",name:"中"},
    { id:"4",name:"低"}
];
// 优先级
const priorityList = [
    { id:"1",name:"紧急"},
    { id:"2",name:"高"},
    { id:"3",name:"中"},
    { id:"4",name:"低"}
];
// 影响范围
const influenceList = [
    { id:"1",name:"业务"},
    { id:"2",name:"部分"},
    { id:"3",name:"个人"},
];
// 难易程度
const complexityList = [
    { id:"4",name:"四级:简单的咨询"},
    { id:"3",name:"三级:已知简单故障"},
    { id:"2",name:"二级:需要较多时间解决的故障"},
    { id:"1",name:"一级:未知的故障解决"},
];
const slaList = [
    { id:"1",name:"默认SLA"},
    { id:"2",name:"60分钟SLA"},
    { id:"3",name:"120分钟SLA"},
]


export {
    statusLists,categoryList,categoryList2,originList,emergencyList,priorityList,influenceList,complexityList,slaList,
}
